import React, { useState, useEffect } from 'react';
import { Modal, Form, InputNumber, message } from 'antd';
import AccountBalanceService from '../../service/account-balance-service/Account-balance.service';
import useUserStorage from '../../hook/useUserStorage';
import EmployeeService from '../../service/employee-service/Employee.service';

interface AddMoneyModalProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  balanceId: number;
}

const AddMoneyModal: React.FC<AddMoneyModalProps> = ({
  visible,
  onCancel,
  onSuccess,
  balanceId,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { user } = useUserStorage();
  const [employeeId, setEmployeeId] = useState<number | null>(null);

  useEffect(() => {
    const fetchEmployeeId = async () => {
      if (user) {
        try {
          const employeeData = await EmployeeService.getEmployeeByUserId(
            user.id
          );
          setEmployeeId(employeeData.id);
        } catch (error) {
          console.error('Error fetching employee data:', error);
          message.error('Không thể lấy thông tin nhân viên');
        }
      }
    };
    fetchEmployeeId();
  }, [user]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (!employeeId) {
        message.error('Không tìm thấy thông tin nhân viên');
        return;
      }

      if (!balanceId) {
        message.error('Không tìm thấy thông tin tài khoản');
        return;
      }

      await AccountBalanceService.addMoneyForBank(
        balanceId,
        values.amount,
        employeeId
      );

      message.success('Thêm tiền thành công');
      form.resetFields();
      onSuccess();
      onCancel();
    } catch (error) {
      console.error('Error adding money:', error);
      message.error('Có lỗi xảy ra khi thêm tiền');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Nạp tiền vào quỹ công ty"
      open={visible}
      onOk={handleSubmit}
      onCancel={onCancel}
      okText="Nạp tiền"
      cancelText="Hủy"
      confirmLoading={loading}
      centered
      className="w-full max-w-lg"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="amount"
          label="Số tiền"
          rules={[{ required: true, message: 'Vui lòng nhập số tiền' }]}
        >
          <InputNumber
            className="w-full"
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
            placeholder="Nhập số tiền"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddMoneyModal;
